import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: { width: '98%' },
  noBorder: { border: 'none' },
  noEndAdornment: { display: 'none' },
  placeHolder: {
    '& input::placeholder': {
      fontSize: '15px',
      color: '#333333',
      opacity: 1
    }
  },
  optionContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  icon: { marginRight: 3, fontSize: 18 },
  rootTextfield: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`
  },
  groupLabel: {
    background: theme.palette.grey[300],
    fontSize: 16,
    lineHeight: '24px',
    // direction: (props: { lang: string }) =>
    //   props.lang === 'fa' ? 'rtl' : 'ltr'
    textAlign: 'left'
  },
  optionFont: { color: theme.palette.text.primary }
}))
export default useStyles
